module.exports = __webpack_public_path__ + "static/3-e9e0bc4ccdbb2f3f89f7deec5a3f4c76.png";